<template>
  <v-col cols="auto" class="pa-0">
    <v-menu
      v-if="videoLinks.length > 0"
      class="pt-10"
      open-on-hover
      close-delay="120"
      transition="slide-x-transition"
      bottom
      left
      offset-y
      nudge-right="5"
      :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          color="#f9f9f9"
          v-bind="attrs"
          v-on="on">
          <v-icon>mdi-help-rhombus-outline</v-icon>
        </v-btn>
      </template>
      <v-card max-width="220" tile>
        <v-list nav dense>
          <v-subheader>Tutorial Videos</v-subheader>
          <v-list-item-group color="primary">
            <v-list-item
              v-for="(link, i) in videoLinks"
              :key="i"
              @click="openVideoPlayer(link.id)">
              {{ link.label }}
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-menu>
    <VideoPlayer
      v-if="showVideoModal"
      v-model="showVideoModal"
      loader-color="light-blue lighten-1"
      :id="videoId"
      @close="closeVideoPlayer">
    </VideoPlayer>
  </v-col>
</template>
<script>
const VideoPlayer = () => import('@/components/VideoPlayer.vue')
export default {
  data () {
    return {
      showVideoModal: false,
      videoId: null,
      videoLinks: [
        {
          id: 'cfff1704-5140-442a-a205-29f38c93382c',
          label: 'Intro to Customers'
        },
        {
          id: '55159ee7-1fd9-4d6a-981d-9bd9589babc9',
          label: 'Customer Information'
        }
      ]
    }
  },
  name: 'VideoMenu',
  components: { VideoPlayer },
  methods: {
    openVideoPlayer (id) {
      this.videoId = id
      this.showVideoModal = true
    },
    closeVideoPlayer () {
      this.showVideoModal = false
      this.videoId = null
    }
  }
}
</script>